import { Component, OnInit, inject } from "@angular/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { DialogOverlayRef } from "@app/core/classes/dialog.ref";
import { InternationalizationService } from "@app/core/services";

@Component({
  selector: "jeopardy-terms-conditions",
  templateUrl: "./terms-conditions.component.html",
  styleUrls: ["./terms-conditions.component.scss"],
  standalone: true,
})
export class TermsConditionsComponent implements OnInit {
  public header: string;
  public message: SafeHtml;
  public cancelButtonLabel: string;

  private overlayRef = inject(DialogOverlayRef);
  private i18n = inject(InternationalizationService);
  private sanitizer = inject(DomSanitizer);

  ngOnInit(): void {
    this.header = this.i18n.str(
      "challengeu.terms_conditions_title",
      "Terms and Conditions"
    )();
    this.cancelButtonLabel = this.i18n.str("challengeu.close", "Close")();
    this.message = this.sanitizer.bypassSecurityTrustHtml(
      this.i18n.str(
        "challengeu.terms_conditions",
        `
    Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, 
    making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, 
    consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. 
    Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum" (The Extremes of Good and Evil) by Cicero, written in 45 BC.
    This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, "Lorem ipsum dolor sit amet..", 
    comes from a line in section 1.10.32.
    `
      )()
    );
  }

  close(event: Event) {
    event.preventDefault();
    this.overlayRef.close();
  }
}
